import Glide from '@glidejs/glide';

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.glide')) return;
  const solutionsSlider = new Glide('.solutions-slider', {
    type: 'carousel',
    perView: 1,
    autoplay: 10000,
    hoverpause: false,
  });
  solutionsSlider.mount();
});
